import ko from "knockout";

export type ValidationError = {
    field: string;
    message: string;
};

export default class FeedbackHelper {
    visitedReferences: any[] = [];

    listInvalidFields = (object: any): ValidationError[] => {
        this.visitedReferences = [];

        return this.visit(object, "");
    };

    private isAlreadyVisited = (object: any) => {
        for (let i = 0; i < this.visitedReferences.length; i++) {
            if (this.visitedReferences[i] === object) {
                return true;
            }
        }

        return false;
    };

    private isMyFlow = (obj: any) => {
        return !!obj.isMyFlow;
    };

    private isNode = (obj: any) => {
        return obj instanceof Node;
    };

    private isPrimitive = (obj: any) => {
        return obj !== Object(obj);
    };

    private isNullOrUndefined = (object: any) => {
        return object === null || object === undefined;
    };

    private isObject = (object: any) => {
        return typeof object == "object";
    };

    private isObservable = (object: any) => {
        return ko.isObservable(object);
    };

    private isValidatable = (object: any) => {
        return !!(object.rules && object.isValid && object.isModified);
    };

    private isInvalid = (object: any) => {
        return !object.isValid();
    };

    private isArray = (object: any) => {
        return object instanceof Array;
    };

    private ignoreProperty = (propertyName: string) => {
        // Avoid going into ko mapping, myFlow etc
        return propertyName.indexOf("__") === 0;
    };

    private visit = (object: any, currentPath: string): ValidationError[] => {
        if (
            this.isNullOrUndefined(object) ||
            this.isPrimitive(object) ||
            this.isNode(object) ||
            this.isMyFlow(object)
        ) {
            return [];
        }

        // Break loops
        if (this.isAlreadyVisited(object)) {
            return [];
        }

        // Mark as visited
        this.visitedReferences.push(object);

        if (this.isObservable(object)) {
            if (this.isValidatable(object)) {
                if (this.isInvalid(object)) {
                    return [
                        {
                            field: currentPath,
                            message: object.error()
                        }
                    ];
                }
                return this.visit(object(), currentPath + "()");
            }

            return this.visit(object(), currentPath + "()");
        }

        let list: ValidationError[];

        if (this.isArray(object)) {
            list = [];

            object.forEach((item: any, index: number) => {
                list = list.concat(this.visit(item, currentPath + "[" + index + "]"));
            });

            return list;
        }

        if (this.isObject(object)) {
            list = [];

            Object.keys(object)
                .filter(key => !this.ignoreProperty(key))
                .forEach(key => {
                    list = list.concat(this.visit(object[key], currentPath + "." + key));
                });

            return list;
        }

        return [];
    };
}
